import { optionTitle_VoiceMail } from './VoiceMailOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

const lazyFullModule = new LazyModule(() => import('./lazyOption'));

let VoiceMailOption: LazyOption = createLazyOption(
    {
        key: 'voicemail',
        titleStringKey: optionTitle_VoiceMail,
        searchTermsStringKey: optionTitle_VoiceMail,
        allowedOptionKeys: ['VoiceAccess'],
        hideTitleInFullOptions: true,
        isHidden: () => isConsumer(),
    },
    lazyFullModule,
    m => m.default
);

export default VoiceMailOption;
